
import { mapState } from 'vuex'

export default {
    computed: {
        ...mapState({
            showForm: state => state.showForm,
        }),
    },
}
